import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_278: DocMigration = {
  maxSchemaVersion: "0.0.278",
  description: "Move window material settings into materials field",
  apply(json: any) {
    const settingsSetId = uid();
    const settingsSet = {
      entityType: "SETTINGS_SET",
      name: "Window Material Settings",
      id: settingsSetId,
      sortIndex: 0,
    };

    const windowMaterialSettingId = uid();
    const windowMaterialSettings = {
      entityType: "SETTINGS",
      type: "WINDOW_MATERIAL_SETTINGS",
      id: windowMaterialSettingId,
      name: "Window Material Settings",
      sortIndex: 0,
      parentId: settingsSetId,
      frameMaterial: "trimExterior0",
      integralMullionMaterial: "trimExterior0",
    };

    json.settings[windowMaterialSettingId] = windowMaterialSettings;
    json.settingsSets[settingsSetId] = settingsSet;

    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];

      if (setting.type !== "WINDOW_CATALOG_SETTINGS") {
        continue;
      }

      if (!setting.windowTypes) {
        continue;
      }

      for (const id in setting.windowTypes) {
        const windowType = setting.windowTypes[id];
        setting.windowTypes[id] = materialPropertiesToMaterialField(windowType);
      }
    }

    for (const windowId in json.openings) {
      const window = json.openings[windowId];

      json.openings[windowId] = materialPropertiesToMaterialField(window);
    }

    return json;
  },
};

export default migration_0_0_278;

const materialProperties = [
  "panelType",
  "glazingType",
  "glazingColor",
  "frameMaterial",
  "integralMullionMaterial",
  "ventMaterial",
  "sashMaterial",
  "gridMaterial",
];

function materialPropertiesToMaterialField(entity: any) {
  const materials = {};
  let materialPropertyFound = false;
  for (const key of materialProperties) {
    if (!(key in entity)) {
      continue;
    }
    materialPropertyFound = true;
    materials[key] = entity[key];
  }
  if (materialPropertyFound) {
    entity.materials = materials;
  }

  return entity;
}
